export default {
  // customized mutations
  receiveCoaches(state, data) {
    state.coaches = data;
  }
}